module.exports = __webpack_public_path__ + "d664201f/img/ion_calendar-number.3ac5bd07.svg";